import React from "react";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

import { useAppDispatch, useAppSelector } from "../../../../redux/store";
import { fetchAuth } from "../../../../redux/profile/authAndReg/asyncActions";

import { PhoneInput, PasswordInput, Button } from "../../../../components";

import { ValidMessages } from "../../../../resources/locale";

import styles from "./AuthForm.module.scss";
import logo from "../../../../assets/img/logo.svg";

import { SubmitValueType, AuthFormPropsType } from "./types";
import { cleanPhone } from "@/utils/form/phoneMask";

export const AuthForm: React.FC<AuthFormPropsType> = (props) => {
  const dispatch = useAppDispatch();

  const { handleChangePass } = props;

  const { isLoading, errorMessage } = useAppSelector(state => state.authAndReg);  

  const initialValues = {
    phone: "",
    password: "",
  };

  const validationSchema = Yup.object({
    phone: Yup.string()
      .min(18, ValidMessages.inputs.phone.NOT_FULL)
      .required(ValidMessages.inputs.phone.REQUIRED),
    password: Yup.string()
      .required(ValidMessages.inputs.password.REQUIRED)
      .min(6, ValidMessages.inputs.password.NOT_FULL),
  });

  const handleSubmit = async (values: SubmitValueType, { setSubmitting }: any) => {
    const data = {
      phone: cleanPhone(values.phone),
      password: values.password,
    }

    try {
      await dispatch(fetchAuth(data)).unwrap();
    } catch (error) {
      // Ошибка обрабатывается в slice и отображается через errorMessage
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      validateOnChange={false}
      validateOnBlur={true}
    >
      {(formik) => {
        const isPhoneFilled = formik.values.phone.trim().length >= 18;
        const isPasswordFilled = formik.values.password.trim().length >= 6;
        const isFormValid = isPhoneFilled && isPasswordFilled;

        return (
          <Form className={styles.form}>
            <div className={styles.formSection}>
              <PhoneInput name="phone" lable="Телефон" placeholder="+7 (___) ___-__-__" />
              <ErrorMessage
                component="div"
                className={styles.errorMessage}
                name="phone"
              />
            </div>
            <div className={styles.formSection}>
              <PasswordInput name="password" lable="Пароль" placeholder="Пароль" />
              <ErrorMessage
                component="div"
                className={styles.errorMessage}
                name="password"
              />
            </div>
            {
              errorMessage ? (
                <div className={styles.errorMessage}>
                  {
                    errorMessage.includes('Not allowed')
                      ? "Сервер временно недоступен"
                      : errorMessage.includes('Invalid phone') || errorMessage.includes('Invalid password')
                        ? "Неверный номер телефона или пароль"
                        : errorMessage
                  }
                </div>
              ) : null
            }
            <div className={styles.forgotPassword}>
              <a href="#" className={styles.link} onClick={handleChangePass}>
                Забыли пароль?
              </a>
            </div>
            <Button
              type="submit"
              newStyles={styles.button}
              disabled={formik.isSubmitting || isLoading || !isFormValid}
            >
              { isLoading ? "Авторизация..." : "Войти"}
            </Button>
          </Form>
        );
      }}
    </Formik>
  );
};
